import { isAxiosError } from "axios";

export const extractMaybeApiErrorMessage = (err: Error): string => {
  if (!isAxiosError(err)) {
    return err.message;
  }

  return JSON.stringify(err.response?.data) ?? err.message;
};
